import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { ReactNode, useEffect, useState } from 'react';
import { api } from '@/lib/api';

interface PayPalConfig {
  clientId: string;
  enabled: boolean;
}

export function PayPalProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<PayPalConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get<{ plans: any[]; clientId?: string; enabled?: boolean }>('/subscriptions/plans')
      .then(data => {
        setConfig({
          clientId: data.clientId || '',
          enabled: data.enabled !== false && !!data.clientId,
        });
      })
      .catch(() => setConfig({ clientId: '', enabled: false }))
      .finally(() => setLoading(false));
  }, []);

  if (loading || !config?.enabled || !config.clientId) {
    return <>{children}</>;
  }

  return (
    <PayPalScriptProvider options={{
      clientId: config.clientId,
      vault: true,
      intent: 'subscription',
      currency: 'EUR',
    }}>
      {children}
    </PayPalScriptProvider>
  );
}
